<template>
  <div>
    <v-row class="white mx-0 mb-4 px-4 pt-4 pb-0 list-box-Shadow">
      <v-col cols="7" class="d-flex align-center">
        <span class="text-h5 text-uppercase font-weight-bold text_color--text">
          Dashboard
        </span>
      </v-col>
    </v-row>
    <v-row class="ma-0 pb-2 px-4">
      <v-col cols="12" class="d-flex align-center py-4 px-4 white rounded-lg">
        <span class="text-capitalize font-weight-bold primary--text">
          Status
        </span>
      </v-col>
    </v-row>
    <v-row
      class="px-1 ma-0"
      v-if="
        statistics &&
        statistics.status_wise_statistics &&
        Object.keys(statistics.status_wise_statistics).length > 0
      "
    >
      <v-col
        v-for="(value, key, index) of statistics.status_wise_statistics"
        :key="index"
        cols="3"
        class="py-2"
      >
        <v-card class="px-5 py-3 rounded-lg" elevation="0" tile>
          <v-card-title class="d-flex justify-start pa-0">
            <span
              class="text-capitalize text-center text-caption"
              style="white-space: nowrap"
            >
              {{ key.replace(/_/g, "  ") }}
            </span>
          </v-card-title>
          <v-card-text class="d-flex justify-start pa-0 mt-2">
            <!-- <v-btn small class="h-100 btn-box display-lg-none mr-3" depressed>
              <v-icon :color="getOrderStatusColor(key, true)" small>
                mdi-archive
              </v-icon>
            </v-btn> -->
            <h2 class="font-weight-bold d-flex align-center">
              {{ value }}
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ma-0 py-5 px-4">
      <v-col cols="12" class="d-flex align-center py-4 px-4 white rounded-lg">
        <span class="text-capitalize font-weight-bold primary--text">
          Impact
        </span>
      </v-col>
    </v-row>
    <v-row
      class="px-1 ma-0"
      v-if="
        statistics &&
        statistics.impact_wise_statistics &&
        Object.keys(statistics.impact_wise_statistics).length > 0
      "
    >
      <v-col
        v-for="(value, key, index) of statistics.impact_wise_statistics"
        :key="index"
        cols="3"
        class="py-0"
      >
        <v-card class="px-5 py-3 rounded-lg" elevation="0" tile>
          <v-card-title class="d-flex justify-start pa-0">
            <span
              class="text-capitalize text-center text-caption"
              style="white-space: nowrap"
            >
              {{ key.replace(/_/g, "  ") }}
            </span>
          </v-card-title>
          <v-card-text class="d-flex justify-start pa-0 mt-2">
            <!-- <v-btn small class="h-100 btn-box display-lg-none mr-3" depressed>
              <v-icon :color="getOrderStatusColor(key, true)" small>
                mdi-archive
              </v-icon>
            </v-btn> -->
            <h2 class="font-weight-bold d-flex align-center">
              {{ value }}
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ma-0 py-5 px-4">
      <v-col cols="12" class="d-flex align-center py-4 px-4 white rounded-lg">
        <span class="text-capitalize font-weight-bold primary--text">
          Priority Wise
        </span>
      </v-col>
    </v-row>
    <v-row
      class="px-1 ma-0"
      v-if="
        statistics &&
        statistics.priority_wise_statistics &&
        Object.keys(statistics.priority_wise_statistics).length > 0
      "
    >
      <v-col
        v-for="(value, key, index) of statistics.priority_wise_statistics"
        :key="index"
        cols="3"
        class="py-0"
      >
        <v-card class="px-5 py-3 rounded-lg" elevation="0" tile>
          <v-card-title class="d-flex justify-start pa-0">
            <span
              class="text-capitalize text-center text-caption"
              style="white-space: nowrap"
            >
              {{ key.replace(/_/g, "  ") }}
            </span>
          </v-card-title>
          <v-card-text class="d-flex justify-start pa-0 mt-2">
            <!-- <v-btn small class="h-100 btn-box display-lg-none mr-3" depressed>
              <v-icon :color="getOrderStatusColor(key, true)" small>
                mdi-archive
              </v-icon>
            </v-btn> -->
            <h2 class="font-weight-bold d-flex align-center">
              {{ value }}
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { supportModule } from "@/utils/moduleMapping";
export default {
  data() {
    return {
      supportModule,
      statistics: {},
    };
  },
  methods: {
    getTripChartData() {
      this.$api.supportUserTicket
        .getSupportStatistics()
        .then((res) => {
          this.statistics = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getTripChartData();
  },
};
</script>

<style>
</style>